const localeArray = [
  {
    locale: 'en_US',
    language: 'English'
  },
  {
    locale: 'de_DE',
    language: 'German'
  },
  {
    locale: 'ar_EG',
    language: 'Arabic'
  },
  {
    locale: 'az_AZ',
    language: 'Azerbaijani'
  },
  {
    locale: 'bg_BG',
    language: 'Bulgarian'
  },
  {
    locale: 'by_BY',
    language: 'Belarusian'
  },
  {
    locale: 'ca_ES',
    language: 'Catalan'
  },
  {
    locale: 'cs_CZ',
    language: 'Czech'
  },
  {
    locale: 'da_DK',
    language: 'Danish'
  },
  {
    locale: 'el_GR',
    language: 'Greek'
  },
  {
    locale: 'en_GB',
    language: 'English (United Kingdom)'
  },
  {
    locale: 'es_ES',
    language: 'Spanish'
  },
  {
    locale: 'et_EE',
    language: 'Estonian'
  },
  {
    locale: 'fa_IR',
    language: 'Persian'
  },
  {
    locale: 'fi_FI',
    language: 'Finnish'
  },
  {
    locale: 'fr_BE',
    language: 'French (Belgium)'
  },
  {
    locale: 'fr_CA',
    language: 'French (Canada)'
  },
  {
    locale: 'fr_FR',
    language: 'French (France)'
  },
  {
    locale: 'ga_IE',
    language: 'Irish (Ireland)'
  },
  {
    locale: 'gl_ES',
    language: 'Galician (Spain)'
  },
  {
    locale: 'he_IL',
    language: 'Hebrew'
  },
  {
    locale: 'hi_IN',
    language: 'Hindi'
  },
  {
    locale: 'hr_HR',
    language: 'Croatian'
  },
  {
    locale: 'hu_HU',
    language: 'Hungarian'
  },
  {
    locale: 'hy_AM',
    language: 'Armenian'
  },
  {
    locale: 'id_ID',
    language: 'Indonesian'
  },
  {
    locale: 'it_IT',
    language: 'Italian'
  },
  {
    locale: 'is_IS',
    language: 'Icelandic'
  },
  {
    locale: 'ja_JP',
    language: 'Japanese'
  },
  {
    locale: 'kmr_IQ',
    language: 'Kurdish (Kurmanji)'
  },
  {
    locale: 'kn_IN',
    language: 'Kannada'
  },
  {
    locale: 'kk_KZ',
    language: 'Kazakh'
  },
  {
    locale: 'ko_KR',
    language: 'Korean'
  },
  {
    locale: 'lt_LT',
    language: 'Lithuanian'
  },
  {
    locale: 'lv_LV',
    language: 'Latvian'
  },
  {
    locale: 'mk_MK',
    language: 'Macedonian'
  },
  {
    locale: 'mn_MN',
    language: 'Mongolian'
  },
  {
    locale: 'ms_MY',
    language: 'Malay (Malaysia)'
  },
  {
    locale: 'nb_NO',
    language: 'Norwegian'
  },
  {
    locale: 'ne_NP',
    language: 'Nepal'
  },
  {
    locale: 'nl_BE',
    language: 'Dutch (Belgium)'
  },
  {
    locale: 'nl_NL',
    language: 'Dutch'
  },
  {
    locale: 'pl_PL',
    language: 'Polish'
  },
  {
    locale: 'pt_BR',
    language: 'Portuguese (Brazil)'
  },
  {
    locale: 'pt_PT',
    language: 'Portuguese'
  },
  {
    locale: 'ro_RO',
    language: 'Romanian'
  },
  {
    locale: 'ru_RU',
    language: 'Russian'
  },
  {
    locale: 'sk_SK',
    language: 'Slovak'
  },
  {
    locale: 'sr_RS',
    language: 'Serbian'
  },
  {
    locale: 'sl_SI',
    language: 'Slovenian'
  },
  {
    locale: 'sv_SE',
    language: 'Swedish'
  },
  {
    locale: 'ta_IN',
    language: 'Tamil'
  },
  {
    locale: 'th_TH',
    language: 'Thai'
  },
  {
    locale: 'tr_TR',
    language: 'Turkish'
  },
  {
    locale: 'uk_UA',
    language: 'Ukrainian'
  },
  {
    locale: 'vi_VN',
    language: 'Vietnamese'
  },
  {
    locale: 'zh_CN',
    language: 'Chinese (Simplified)'
  },
  {
    locale: 'zh_HK',
    language: 'Chinese (Traditional)'
  },
  {
    locale: 'zh_TW',
    language: 'Chinese (Traditional)'
  }
];

export default localeArray;
